export const API_BASE = process.env.REACT_APP_API_URL || '';
export const CV_URL = process.env.REACT_APP_CV_URL || 'https://res.cloudinary.com/dmwyri1xf/image/upload/v1788873077/Bernard_Banda_CV_fkybv2.pdf';
